import { Box, Checkbox, TextField } from '@mui/material'
import { ValidateInt } from '../../../../../../../../../../core/validator/Validator'

export const Details = ({inputs, handlerChange, prodTemplate}) => {
    const handlerShowText = (e) => {
        const { name, checked } = e.target
        const state = {...prodTemplate.data.inputs}
        state[name].show = checked
        prodTemplate.set({...prodTemplate.data, state })
    }
    
    return (
        <Box p={2} display="flex" flexDirection="column" gap="16px" height="100%" width="100%">
            <Box display="flex" flexDirection="column" gap="8px">
                <Box display="flex" fontWeight={600}>Promo File Name<Box color="#FA3E3E">*</Box></Box>
                <TextField size="small" name="promo_name" onChange={(e) => handlerChange(e)} 
                    value={inputs.promo_name.value} error={inputs.promo_name.stat} helperText={inputs.promo_name.msg}
                />
            </Box>
            <Box display="flex" flexDirection="column" gap="8px">
                <Box fontWeight={600}>Promo Duration</Box>
                <Box>
                    <Box display="flex" fontWeight={600}>Start<Box color="#FA3E3E">*</Box></Box>
                    <TextField type="date" size='small' fullWidth name="start" onChange={(e) => handlerChange(e)} 
                        value={inputs.start.value} error={inputs.start.stat} helperText={inputs.start.msg}
                    />
                </Box>
                <Box>
                    <Box display="flex" fontWeight={600}>End<Box color="#FA3E3E">*</Box></Box>
                    <TextField type="date" size='small' fullWidth name="end" onChange={(e) => handlerChange(e)} 
                        value={inputs.end.value} error={inputs.end.stat} helperText={inputs.end.msg}
                        InputProps={{ inputProps: {min: inputs.start.value} }}
                    />
                </Box>
            </Box>
            <Box display="flex" flexDirection="column" gap="8px">
                <Box fontWeight={600}>Promo Limit Per Day</Box>
                <TextField size="small" name="promo_limit" value={inputs.promo_limit.value} onChange={(e) => handlerChange(e)} 
                    onKeyPress={ValidateInt}
                />
            </Box>
            <Box display="flex" flexDirection="column" gap="8px">
                <Box fontWeight={600}>Text Promo Valid</Box>
                <Box display="flex" alignItems="center" gap="8px">
                    <Checkbox name='text_promo' value={inputs.text_promo.show} onChange={(e) => handlerShowText(e)} />
                    <Box>Show this text</Box>
                </Box>
                <TextField size="small" name='text_promo' value={inputs.text_promo.value} onChange={(e) => handlerChange(e)} />
            </Box>
        </Box>
    )
}
